import { useState } from "react";

type PropType = {
  text: string;
  maxLength: number;
};

const LongText = ({ maxLength, text }: PropType) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const displayText = isCollapsed ? text.slice(0, maxLength) : text;

  return (
    <div className="text-[#727272] text-sm md:text-base font-normal">
      <span>{displayText}</span>
      {text.length > maxLength && (
        <span onClick={toggleCollapse} className="text-primary cursor-pointer">
          {isCollapsed ? "... Read More" : " Read Less"}
        </span>
      )}
    </div>
  );
};

export default LongText;
